<app-simple-select [inline]="inline" [autoOpen]="autoOpen"
                   [multiple]="multiple"
                   [allowEmpty]="allowEmpty"
                   translationPrefix="select.location_status"
                   [selectList]="selectList"
                   [(selectedItems)]="selectedItems"
                   (selectedItemsChange)="updateData()">
</app-simple-select>
